module.exports = __webpack_public_path__ + "media/applicants/shoppericon-731e9c88.svg";